import { Modal } from 'rewire-ui';

interface AboutDialogModelState {
  version?: string;
}

export class AboutDialogModel extends Modal<AboutDialogModelState> {
  constructor() {
    super();

    this.action('done');
  }

  reset() {
    this.state.version = undefined;
  }

  load() {
    this.state.version = '0.32.0';
    this.open();
  }

  get version(): string | undefined {
    return this.state.version;
  }
}

const aboutDialogModel = new AboutDialogModel();
export default aboutDialogModel;
